export default function calculateTimeLeftV2(time) {
  const remainingTime = +new Date(time) - +new Date();
  let timeLeft = {};
  if (remainingTime > 0) {
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));

    // From 2Apr2025, the business changes the way to calculate hours
    // if days > 0, hours = hours + days * 24
    // Be careful when using this hours
    const hours = `${Math.floor(((remainingTime / (1000 * 60 * 60)) % 24) + days * 24)
      .toString()
      .padStart(2, '0')}`;
    const minutes = `${Math.floor((remainingTime / 1000 / 60) % 60)
      .toString()
      .padStart(2, '0')}`;
    const seconds = `${Math.floor((remainingTime / 1000) % 60)
      .toString()
      .padStart(2, '0')}`;

    timeLeft = {
      days,
      hours,
      minutes,
      seconds,
    };
  }
  return timeLeft;
}
